import React, { useCallback, useEffect, useState } from "react";
import cookie from "react-cookies";
import { AFREECATV_DOMAIN } from "../../constants/config";
import { DARKMODE_CLASS_NAME, DARKMODE_CLASS_VALUE, THEME_COOKIE_NAME } from "../../constants/theme";
import { useAuth } from "../../contexts/AuthProvider";
import { setClickLog } from "../../helpers";

var DarkMode = function DarkMode() {
  var _a = useState(false),
      darkMode = _a[0],
      setDarkMode = _a[1];

  var adFrame = useAuth().adFrame;
  /**
   * componentDidMount
   */

  useEffect(function () {
    var theme = cookie.load("theme");
    setDarkMode(theme === "dark");
  }, []);
  var handleDarkModeChange = useCallback(function (e) {
    console.log("handleDarkModeChange", e, e.target.checked);

    if (e.target.checked) {
      setClickLog("conf_00000001", {
        theme_color: "dark"
      });
      var expires = new Date();
      expires.setFullYear(2038, 0, 1);
      cookie.save(THEME_COOKIE_NAME, DARKMODE_CLASS_NAME, {
        domain: AFREECATV_DOMAIN,
        path: "/",
        expires: expires
      });
      document.body.classList.add(DARKMODE_CLASS_VALUE);
      document.documentElement.setAttribute("dark", "true");
      setDarkMode(true);
      play();
    } else {
      setClickLog("conf_00000001", {
        theme_color: "light"
      });
      cookie.remove(THEME_COOKIE_NAME, {
        domain: AFREECATV_DOMAIN,
        path: "/"
      });
      document.body.classList.remove(DARKMODE_CLASS_VALUE);
      document.documentElement.removeAttribute("dark");
      setDarkMode(false);
      play();
    }
  }, []);

  var play = function play() {
    var animItem = window.animItem;
    var lottie = window.bodymovin; // 스크립트 로드

    var theme = cookie.load("theme");
    var svgContainer = document.querySelector('.gauge');
    var headerPath = theme === 'dark' ? '//res.onlive.vn/images/lottie/adballoon_header_dark.json?_=' + new Date().getTime() : '//res.onlive.vn/images/lottie/adballoon_header.json?_=' + new Date().getTime();

    var _gauge_svg = document.querySelector('.gauge svg');

    if (_gauge_svg != null && animItem != null) {
      animItem.destroy();
    }

    if (animItem) {
      var animItem_1 = lottie.loadAnimation({
        wrapper: svgContainer,
        animType: 'svg',
        loop: false,
        autoplay: false,
        path: headerPath
      });
      animItem_1.addEventListener('DOMLoaded', function (event) {
        animItem_1.playSegments([0, adFrame], true);
      });
      window.animItem = animItem_1;
    }
  };

  return React.createElement("div", {
    className: "modeSet"
  }, React.createElement("strong", {
    className: "my_mode"
  }, "Ch\u1EBF \u0111\u1ED9 t\u1ED1i"), React.createElement("input", {
    type: "checkbox",
    id: "modecheck",
    onChange: handleDarkModeChange,
    checked: darkMode
  }), React.createElement("label", {
    className: "modecheck",
    htmlFor: "modecheck"
  }), React.createElement("p", null, "Ch\u1EC9 \xE1p d\u1EE5ng cho tr\xECnh duy\u1EC7t n\xE0y"));
};

export default DarkMode;